// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_nze","cls2":"ResearchExamples-cls2_KGS ResearchExamples-cls1_nze","cropped":"ResearchExamples-cropped_hDQ"};